import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getBodyStyle, getColor, Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const AuthorHeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 95%;

  @media (${breakpoint.mdMin}) {
    flex-direction: row;
    flex-wrap: wrap;
  }
  @media (${breakpoint.lgMin}) {
    width: 100%;
  }
`;

export const AuthorName = styled(Heading)`
  letter-spacing: -0.75px;
  text-align: center;
  margin-bottom: 8px;
  margin-top: 48px;
  @media (${breakpoint.mdMin}) {
    letter-spacing: -1px;
    text-align: left;
  }
  @media (${breakpoint.xxlMin}){
    letter-spacing: -1.5px;
    line-height: 115px;
    width: 100%;
  }
`;

export const AuthorImage = styled.div<{ theme: Theme }>`
  height: 200px;
  min-height: 200px;
  min-width: 200px;
  width: 200px;
  text-align: center;
  margin: auto;
  margin-bottom: 16px;
  border: 1px solid ${getColor('borderTertiary')};
  box-shadow: 4px 4px 0 0 ${getColor('surfaceBlack')};
  
  @media (${breakpoint.mdMin}) {
    margin: 16px 16px 16px 0;
    text-align: left;
    width: 200px;
  }

  @media (${breakpoint.lgMin}) {
    margin: 18px 40px 16px 0;
  }
`;

export const AuthorDescription = styled.div<{ theme: Theme }>`
  flex: 1;
  ${getBodyStyle('graphikCompact', { default: 'default' })};
  margin: 0 0 16px 16px;
  a {
    color: ${getColor('textLink')};
    &:hover {
      color: ${getColor('textSecondary')};
    }
  }
  p {
    margin-top: 17px; // margin-block-start: 1em = 17px
    margin-bottom: 17px; // margin-block-start: 1em = 17px
  }
  em,
  i {
    font-style: italic;
  }
  b,
  strong {
    font-weight: 500;
  }

  @media (${breakpoint.lgMin}) {
    margin: 0 0 16px 0;
  }
`;

export const AuthorSocials = styled.div<{ theme: Theme }>`
  ul.social-list {
    color: ${getColor('textPrimary')};
    display: flex;
    flex: 1 1 100%;
    flex-direction: column;
    font-family: ${font.graphikCond};
    font-weight: 500;
    justify-content: flex-start;
    margin: 8px 0 16px 16px;
    svg {
      width: 18px;
      height: 18px;
      margin-right: 8px;
      margin-bottom: -1.5px;
      fill: ${getColor('iconPrimary')};
    }
    a {
      color: ${getColor('textPrimary')};
      text-decoration: none;
    }
    .social {
      justify-content: left;
      margin-top: 24px;
      padding-right: 32px;
      @media (${breakpoint.mdMin}) {
        margin-top: 0;
      }
      @media (${breakpoint.xlMin}) {
        padding-right: 32px;
      }
      &:first-child {
        margin: 0;
      }
    }
    @media (${breakpoint.mdMin}){
      flex-direction: row;
      margin-left: 0px;
    }
  }
`;
